import { EmployeesProvider } from "domain/Employee";
import { FiltersProvider } from "domain/Filters";
import { HistoryProvider } from "domain/History";
import { InvoicesProvider } from "domain/Invoice";
import { InventoryActionsProvider, InventoryPaginationProvider } from "domain/Inventory/context";
import { LocationsProvider } from "domain/Location";
import { SortingProvider } from "domain/Sorting";

export const HomePageProvider = ({ children }) => (
  <SortingProvider storageKey="homeSorting">
    <LocationsProvider>
      <FiltersProvider storageKey="homeFilters">
        <EmployeesProvider>
          <InvoicesProvider>
            <HistoryProvider loadHistories={false}>
              <InventoryActionsProvider>
                <InventoryPaginationProvider rememberLastList>{children}</InventoryPaginationProvider>
              </InventoryActionsProvider>
            </HistoryProvider>
          </InvoicesProvider>
        </EmployeesProvider>
      </FiltersProvider>
    </LocationsProvider>
  </SortingProvider>
);
